import { render, staticRenderFns } from "./trafficlinechart.component.vue?vue&type=template&id=a5fb0ede&scoped=true"
import script from "./trafficlinechart.component.vue?vue&type=script&lang=js"
export * from "./trafficlinechart.component.vue?vue&type=script&lang=js"
import style0 from "./trafficlinechart.component.vue?vue&type=style&index=0&id=a5fb0ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fb0ede",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
